.tabRoot {
}

.tabsList {
  border-radius: 18px;
  display: flex;
  background-color: var(--mantine-color-gray-1);
}

.tabPanel {
}

.tab {
  border-radius: 16px;
  margin: var(--mantine-spacing-xxxs);
  border: none;
  flex: 1;
  &[data-active='true'] {
    background-color: var(--mantine-color-gray-0);
    color: var(--mantine-color-gray-10);
    font-weight: 700;

    .tabLabel {
      font-weight: 700;
    }
  }
  &:not([data-active='true']) {
    background-color: transparent;
    color: var(--mantine-color-gray-5);

    .tabLabel {
      font-weight: 500;
    }
  }
}

.tab[data-active='true'] {
  /*background-color: var(--mantine-color-blue-9); !* Selected tab *!*/
}

.tabSection {
}
